import { useContext } from "react"
import { stateContext } from "./ctx"
import Dots from './Dots';
const Mesh = () => {
    const {bgMesh,bgColor} = useContext(stateContext)
    return <div className='flex-1 group ml-3 rounded-xl shadow-mini' style={{backgroundImage:bgMesh,backgroundColor:bgColor}}>
        <Dots />
    </div>
   
}

export default Mesh